import { Disputes } from './models/disputes.model copy';
import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards/auth.guard';
import { changePasswordGuard } from '../../core/guards/change-password.guard';
import { platformContentRoutes } from './pages/platform-content/platform-content.routes';
import { validationRoutes } from './pages/validations/validation.routes';
import { permissionGuard } from '../../core/guards/permission-guard';
import { pendingApprovalsRoutes } from './pages/pending-approvals/pending-approvals.routes';
import { contentModerationRoutes } from './pages/content-moderation/content-moderation.routes';
import { configurationPanelRoutes } from './pages/configuration-panel/configuration-panel.routes';

export const dashboardRoutes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [permissionGuard],

    loadComponent: () => import('./dashboard').then((m) => m.Dashboard),
    children: [
      {
        path: '',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () =>
          import('./pages/dashboard-panel/dashboard-panel').then((m) => m.DashboardPanel),
      },
      {
        path: 'account-settings',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () =>
          import('./pages/account-settings/account-settings').then((m) => m.AccountSettings),
      },
       {
        path: 'disputes',
        canActivate: [authGuard, permissionGuard],
          loadComponent: () =>
          import('./pages/Disputes/disputes').then((m) => m.Disputes),
      },  {
        path: 'broadcast',
        canActivate: [authGuard, permissionGuard],
          loadComponent: () =>
          import('./pages/Broadcast/broadcast').then((m) => m.Broadcast),
      },
      {
        path: 'broadcast/history',
        canActivate: [authGuard, permissionGuard],
          loadComponent: () =>
          import('./pages/Broadcast/broadcast-history/broadcast-history').then((m) => m.BroadcastHistory),
      },
      {
        path: 'validations',
        canActivate: [authGuard, permissionGuard],
        children: validationRoutes,
      },
      {
        path: 'admins',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () => import('./pages/accounts/accounts').then((m) => m.Accounts),
      },
      {
        path: 'permissions',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () => import('./pages/permissions/permissions').then((m) => m.Permissions),
      },
      {
        path: 'users',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () => import('./pages/us-sp/us-sp').then((m) => m.UsSp),
      },
      {
        path: 'profile/:username',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () =>
          import('./pages/us-sp-profile/us-sp-profile').then((m) => m.UsSpProfile),
      },
      {
        path: 'platform-content',
        canActivate: [authGuard, permissionGuard],
        children: platformContentRoutes,
      },
      {
        path: 'pending-approvals',
        canActivate: [authGuard, permissionGuard],
        children: pendingApprovalsRoutes,
      },
      {
        path: 'content-moderation',
        canActivate: [authGuard, permissionGuard],
        children: contentModerationRoutes,
      },
      {
        path: 'reports',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () => import('./pages/reports/reports').then((m) => m.Reports),

       
      },
      {
        path: 'reports/:id',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () => import('./pages/reports/report-details/report-details').then((m) => m.ReportDetails),

       
      }, {
        path: 'configuration-panel',
        canActivate: [authGuard, permissionGuard],
        children: configurationPanelRoutes,
      },
    ],
  },
];
